const $ = require('jquery');
const cookie = require('jquery.cookie');
const validation = require('jquery-validation');
const bootstrap = require('bootstrap');
const moment = require('moment');

window.$ = window.jQuery = $;

const pushy = require('./vendor/pushy-custom');
const custom = require('./custom-validation');
const unobtrusive = require('jquery-validation-unobtrusive');
const expressive = require('expressive-annotations-validate');
const mask = require('jquery-mask-plugin');

const verify = require('./verify');
const cardapp = require('./card-app');

(function () {
    //////////////////////////////////////////////////////////////////////
    // VIEWPORT
    //////////////////////////////////////////////////////////////////////
    var windowSize = $(window).width();
    var ua = navigator.userAgent.toLowerCase();
    var isiPad = navigator.userAgent.match(/iPad/i) !== null;
    if (isiPad) {
        $('meta[name="viewport"]').attr('content', 'width=1024');
        //$('body').addClass('iPad');
    }
    $(window).on("orientationchange", function () {
        var windowSize = $(window).width();
        if (windowSize > 750) {
            $('meta[name="viewport"]').attr('content', 'width=1250');
        }
    });

    //////////////////////////////////////////////////////////////////////
    // METHODS
    //////////////////////////////////////////////////////////////////////
    var highlight = function (element, errorClass, validClass) {
        $(element).addClass(errorClass).removeClass(validClass);
        $(element).parent().addClass(errorClass);
    };

    var unhighlight = function (element, errorClass, validClass) {
        $(element).removeClass(errorClass).addClass(validClass);
        $(element).parent().removeClass(errorClass);
    };


    //////////////////////////////////////////////////////////////////////
    // VARIABLES
    //////////////////////////////////////////////////////////////////////

    var offerCodeValidationRules = {
        onfocusout: function (element) {
            $(element).valid();
        },
        rules: {
            offerCode: {
                required: true,
                regex: "^[0-9a-zA-Z-]*$"
            },
            accessCode: {
                required: true,
                regex: "^[0-9a-zA-Z]*$"
            }
        },
        messages: {
            offerCode: {
                required: 'Please enter your reservation number.',
                regex: 'Please enter a valid reservation number.'
            },
            accessCode: {
                required: 'Please enter your access code.',
                regex: 'Please enter a valid access code.'
            }
        },
        highlight: highlight,
        unhighlight: unhighlight
    };

    //////////////////////////////////////////////////////////////////////
    // RUN ON PAGE LOAD
    //////////////////////////////////////////////////////////////////////

    // Offer Code Form
    $('#offer-code-submission').validate(offerCodeValidationRules);
    $("#offer-code-submission").removeAttr("novalidate");

    $('#offer-code-submission').submit(function () {
        if ($(this).valid()) {
            $(':submit', this).attr('disabled', 'disabled');
        }
    });

})();

// Progress bar class for FED (FSFALLYP1-158)
var currentSection = $('*[id*=section-]').attr('id');
$('.progress-bar').addClass(currentSection);

// Mobile accordion awkward functionality (because comps said so >:|)
if (currentSection == 'section-welcome') {
    $('#mobileAccordion li:not(:nth-of-type(1))').addClass('collapse').attr("id", "collapseAccordion").attr("data-parent", "#mobileAccordion");
}
if (currentSection == 'section-contact') {
    $('#mobileAccordion li:not(:nth-of-type(2))').addClass('collapse').attr("id", "collapseAccordion").attr("data-parent", "#mobileAccordion");
}
if (currentSection == 'section-finance') {
    $('#mobileAccordion li:not(:nth-of-type(3))').addClass('collapse').attr("id", "collapseAccordion").attr("data-parent", "#mobileAccordion");
}
if (currentSection == 'section-security') {
    $('#mobileAccordion li:not(:nth-of-type(4))').addClass('collapse').attr("id", "collapseAccordion").attr("data-parent", "#mobileAccordion");
}
